var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAceIcon17AceDiamondSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12 3 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 34,
    height: 54,
    rx: 4,
    fill: "none",
    stroke: "var(--aa-ink, currentColor)",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "miter"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 24 L22.4 9.5 L26.9 24 M19.8 19.5 H25",
    fill: "none",
    stroke: "var(--aa-accent, #FFAC03)",
    strokeWidth: 1.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.98 L34.59 30.76 L41.07 34 L34.59 37.24 L32 45.02 L29.41 37.24 L22.93 34 L29.41 30.76 Z",
    fill: "var(--aa-ink, currentColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAceIcon17AceDiamondSpark);
export default __webpack_public_path__ + "static/media/ace-icon-17-ace-diamond-spark.39fe65003ce4882590976eb0e588c118.svg";
export { ForwardRef as ReactComponent };